import { canv } from "@/canv/global";
import type { frameWidget } from "@/elements/frame";
import { PresentationWidget } from "@/elements/Presentation/Presentation";
import { getPaddingByContent } from "@/elements/Presentation/utils";
import { Group } from "@/group";
import { generateKeyBetween } from "@/helpers/fractional-indexing";
import PresentationIcon from "@/icons/presentation/PresentationIcon.svg?react";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UsePresentationCreateButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function usePresentationCreateButton({
    setActiveSubMenu,
}: UsePresentationCreateButtonProps): MenuOptionResult {
    const isActive = false;

    const handleClick = () => {
        setActiveSubMenu(null);

        const frameWrapper = canv.canvasController.selected[0];
        const frame = frameWrapper.onlyChild() as frameWidget;

        if (!frame || frame.constructorName !== "frame") {
            throw new Error("Презентация может создаваться только из фрейма");
        }

        const { startX, startY, width, height, indexByParent } = frameWrapper;

        const padding = getPaddingByContent(width, height);
        const presentation = new PresentationWidget(
            startX - padding,
            startY - padding,
            width + padding * 2,
            height + padding * 2,
        );
        presentation.name = "Новая презентация";
        presentation.accountName = canv.getInitDataProp("userName");
        presentation.creatorToken = canv.getInitDataProp("userToken");
        presentation.createdAt = new Date().toISOString();

        presentation.setPadding(padding);
        const group = new Group(true);
        presentation.setParent(group);

        group.resizeGroup(
            width - (group.width - padding * 2),
            height - (group.height - padding * 2),
            "leftBottom",
        );

        presentation.addSlide(frame);

        canv.canvasController.addGroup(group);
        canv.eventManager.openRecord();
        group.fixState("indexByParent");
        group.indexByParent = generateKeyBetween(null, indexByParent);
        group.saveState();
        canv.eventManager.closeRecord();

        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", group);
        canv.eventManager.closeRecord();

        frame.setPresentationUID(presentation.UID);
        //решает проблему при создании презы из фрейма - иконка после этого пропадает и не возникает бага
        canv.widgetMenu.reopen();
    };

    const content = <PresentationIcon />;
    const tippyContent = "Создать презентацию";

    return {
        content,
        handleClick,
        isActive,
        tippyContent,
    };
}
